import { render, staticRenderFns } from "./LocationSeatsManagerModal.template.vue?vue&type=template&id=6cf60362&scoped=true&"
var script = {}
import style0 from "./LocationSeatsManagerModal.template.vue?vue&type=style&index=0&id=6cf60362&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf60362",
  null
  
)

export default component.exports